<template>
  <v-row no-gutters>
    <v-col
      v-for="(slide, index) in videoList.slice(0, 6)"
      :key="index"
      cols="12"
      :md="12"
    >
    <div class="mediaBox pa-2 mb-4">
      <MediaVideoThumb
        :srcThumb="slide.thumbnail"
        sizeHeight="auto"
        :indexThumb="index"
        :vlog="slide"
        :meta="metaObj(slide.meta)"
        :notAvatar="true"
        @openDialogDetail="openDialogDetail(videoList, index, slide)"
      />
    </div>
    </v-col>
    <v-col class="d-flex align-center justify-center">
      <InfiniteLoad @loading="loadmoreData" :disabled="endData"/>
    </v-col>
  </v-row>
</template>
<script>
import MediaVideoThumb from "@/components/Thumbnails/MediaVideoThumb";
import InfiniteLoad from "@/components/InfiniteLoad/InfiniteLoad";
export default {
  name: 'MediaVideoList',
  components: {
    MediaVideoThumb,
    InfiniteLoad
  },
  props: {
    videoList: {
      type: Array,
      default: []
    },
    endData: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  methods: {
    openDialogDetail(photoList, index, slide) {
      this.$emit('openDialogDetail', photoList, index, slide)
    },
    loadmoreData() {
      this.$emit('loadmore')
    },
    metaObj(meta) {
      const res = Array.isArray(meta) ? {} : meta
      return res
    }
  }
};
</script>